import { makeStyles } from "@material-ui/core";

const NEW_COLOR = "#4CAF50";
const FOLLOW_COLOR = "#1976D2";
const CANCELLED_COLOR = "#9E9E9E";

export const GRID_COLORS = {
  NEW: NEW_COLOR,
  FOLLOW: FOLLOW_COLOR,
  CANCELLED: CANCELLED_COLOR,
};

export const useGridStyles = makeStyles((theme) => ({
  scheduleCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2.5),
    height: "100%",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  headerTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  headerIcon: {
    color: theme.palette.primary.main,
  },
  headerTitle: {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  headerControls: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  navGroup: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  navButton: {
    backgroundColor: "#2b2f36",
    color: "#fff",
    borderRadius: 10,
    padding: 6,
    "&:hover": { backgroundColor: "#1f2329" },
  },
  viewToggle: {
    display: "flex",
    backgroundColor: "#2b2f36",
    borderRadius: 10,
    padding: 3,
  },
  viewToggleBtn: {
    minWidth: 56,
    color: "rgba(255,255,255,0.7)",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8rem",
    borderRadius: 8,
    padding: "4px 12px",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
  },
  viewToggleBtnActive: {
    backgroundColor: "#fff",
    color: "#1f2937",
    "&:hover": { backgroundColor: "#fff" },
  },
  scheduleScroll: {
    overflowX: "auto",
  },
  scheduleGrid: {
    display: "grid",
    minWidth: 720,
    border: "1px solid #eef0f3",
    borderRadius: 12,
    overflow: "hidden",
  },
  gridHeadCell: {
    padding: theme.spacing(1.25, 1),
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#6b7280",
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #eef0f3",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
  dayHeadCell: {
    padding: theme.spacing(1.25, 1),
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#374151",
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #eef0f3",
    borderLeft: "1px solid #eef0f3",
    textAlign: "center",
  },
  todayHeadCell: {
    backgroundColor: "#eef4ff",
    color: theme.palette.primary.main,
  },
  timeCell: {
    padding: theme.spacing(1, 1.25),
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#9aa4b2",
    borderBottom: "1px solid #f1f3f5",
    textAlign: "right",
    whiteSpace: "nowrap",
    backgroundColor: "#fff",
  },
  slotCell: {
    minHeight: 46,
    padding: theme.spacing(0.5),
    borderBottom: "1px solid #f1f3f5",
    borderLeft: "1px solid #f1f3f5",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    transition: "background-color 0.15s ease",
    "&:hover": { backgroundColor: "#f8fafc" },
  },
  slotClickable: {
    cursor: "pointer",
  },
  todayCol: {
    backgroundColor: "#fffdf2",
  },
  chip: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 8px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: "0.78rem",
    fontWeight: 600,
    border: "1px solid transparent",
    transition: "all 0.15s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
  },
  chipNew: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    borderColor: "#c8e6c9",
  },
  chipFollow: {
    backgroundColor: "#e3f2fd",
    color: "#1565c0",
    borderColor: "#bbdefb",
  },
  // Cancelled slots stay visible for history but read as inert: greyed,
  // struck through, no pointer, and no hover lift.
  chipCancelled: {
    backgroundColor: "#f3f4f6",
    color: "#9E9E9E",
    borderColor: "#e5e7eb",
    textDecoration: "line-through",
    cursor: "default",
    "&:hover": {
      transform: "none",
      boxShadow: "none",
    },
  },
  chipSelected: {
    borderWidth: 2,
    borderColor: theme.palette.primary.main,
    boxShadow: "0 0 0 2px rgba(17,98,254,0.15)",
  },
  chipDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  chipName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  legend: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: "0.8rem",
    color: "#6b7280",
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
  },
}));
